import script from "./chat.vue?vue&type=script&setup=true&name=Chat&lang=js"
export * from "./chat.vue?vue&type=script&setup=true&name=Chat&lang=js"

import "./chat.vue?vue&type=style&index=0&id=6bbe6df7&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bbe6df7"]])

export default __exports__